import React from 'react';
import { motion } from 'framer-motion';
import ScanQrIcon from '../icons/ScanQrIcon';

const HomeIcon = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? '#D4AF37' : '#8B93A7'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
    <polyline points="9,22 9,12 15,12 15,22" />
  </svg>
);

const ActivityIcon = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? '#D4AF37' : '#8B93A7'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22,12 18,12 15,21 9,3 6,12 2,12" />
  </svg>
);

/** Credit / debit card outline (Cards tab) */
const CardsIcon = ({ active }) => {
  const c = active ? '#D4AF37' : '#8B93A7';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <line x1="2" y1="10" x2="22" y2="10" />
      <rect x="6" y="14" width="4" height="2.5" rx="0.5" fill={c} stroke="none" opacity={active ? 0.9 : 0.85} />
    </svg>
  );
};

const ProfileIcon = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? '#D4AF37' : '#8B93A7'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const BottomNav = ({ current, onNavigate, t, isRTL }) => {
  const leftTabs = [
    { id: 'home', label: t?.home || 'Home', Icon: HomeIcon },
    { id: 'wallet', label: t?.cards || 'Cards', Icon: CardsIcon },
  ];

  const rightTabs = [
    { id: 'activity', label: t?.activity || 'Activity', Icon: ActivityIcon },
    { id: 'profile', label: t?.profile || 'Profile', Icon: ProfileIcon },
  ];

  const renderNavButton = (tab) => (
    <motion.button
      key={tab.id}
      data-testid={`nav-${tab.id}`}
      whileTap={{ scale: 0.85 }}
      onClick={() => onNavigate(tab.id)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '3px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '4px 8px',
        minWidth: '52px',
        flex: 1,
      }}
    >
      <span style={{ display: 'grid', placeItems: 'center', height: '20px', width: '20px' }}>
        <tab.Icon active={current === tab.id} />
      </span>
      {current === tab.id && (
        <motion.div
          layoutId="nav-dot"
          style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#D4AF37' }}
        />
      )}
      {current !== tab.id && (
        <div style={{ width: '4px', height: '4px' }} />
      )}
    </motion.button>
  );

  return (
    <div
      data-testid="bottom-nav"
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '64px',
        background: 'rgba(9,9,9,0.97)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 16px 6px',
        zIndex: 50,
        direction: isRTL ? 'rtl' : 'ltr',
      }}
    >
      {/* Left Section: 2 buttons */}
      <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-start' }}>
        {leftTabs.map(renderNavButton)}
      </div>

      {/* Center: Scan QR Button */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '3px',
          transform: 'translateY(-10px)',
          padding: '0 20px',
        }}
      >
        <motion.button
          data-testid="nav-qrscan"
          whileTap={{ scale: 0.88 }}
          onClick={() => onNavigate('qrscan')}
          style={{
            width: '54px',
            height: '54px',
            minWidth: '54px',
            minHeight: '54px',
            borderRadius: '18px',
            background: 'linear-gradient(135deg, #D4AF37, #B8962E)',
            display: 'grid',
            placeItems: 'center',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 6px 24px rgba(212,175,55,0.45)',
            padding: 0,
            lineHeight: 0,
            flexShrink: 0,
          }}
        >
          <ScanQrIcon size={24} style={{ color: '#0F0F0F' }} />
        </motion.button>
      </div>

      {/* Right Section: 2 buttons */}
      <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
        {rightTabs.map(renderNavButton)}
      </div>
    </div>
  );
};

export default BottomNav;
